export const styles = `
  :host {
    display: block;
    font-family: var(--qb-font-family, system-ui, -apple-system, sans-serif);
    --qb-primary-color: #3b82f6;
    --qb-danger-color: #ef4444;
    --qb-bg-color: #ffffff;
    --qb-border-color: #e5e7eb;
    --qb-text-color: #1f2937;
    --qb-radius: 0.375rem;
    --qb-spacing: 0.5rem;
  }

  .qb-container {
    background: var(--qb-bg-color);
    color: var(--qb-text-color);
    border: 1px solid var(--qb-border-color);
    border-radius: var(--qb-radius);
    padding: var(--qb-spacing);
  }

  .qb-group {
    border: 1px solid var(--qb-border-color);
    border-radius: var(--qb-radius);
    padding: var(--qb-spacing);
    margin-bottom: var(--qb-spacing);
    background: rgba(0, 0, 0, 0.02);
  }

  .qb-group-header {
    display: flex;
    align-items: center;
    gap: var(--qb-spacing);
    margin-bottom: var(--qb-spacing);
  }

  .qb-rule {
    display: flex;
    align-items: center;
    gap: var(--qb-spacing);
    margin-bottom: var(--qb-spacing);
    padding: var(--qb-spacing);
    background: #fff;
    border: 1px solid var(--qb-border-color);
    border-radius: var(--qb-radius);
    flex-wrap: wrap; /* Allow wrapping on small screens */
  }

  .qb-value-group {
    display: flex;
    align-items: center;
    gap: var(--qb-spacing);
    flex: 1;
    min-width: 200px;
  }

  .qb-btn {
    padding: 0.25rem 0.75rem;
    border-radius: var(--qb-radius);
    border: 1px solid var(--qb-border-color);
    background: #fff;
    cursor: pointer;
    font-size: 0.875rem;
    white-space: nowrap; /* Prevent button text wrapping */
  }

  .qb-btn:hover {
    background: #f9fafb;
  }

  .qb-btn-primary {
    background: var(--qb-primary-color);
    color: white;
    border-color: var(--qb-primary-color);
  }

  .qb-btn-primary:hover {
    background: #2563eb;
  }

  .qb-btn-danger {
    color: var(--qb-danger-color);
    border-color: var(--qb-danger-color);
  }

  .qb-btn-danger:hover {
    background: #fef2f2;
  }

  select, input {
    padding: 0.25rem 0.5rem;
    border: 1px solid var(--qb-border-color);
    border-radius: var(--qb-radius);
    font-size: 0.875rem;
    max-width: 100%; /* Ensure inputs don't overflow */
  }

  .qb-tags-container {
    display: flex;
    flex-wrap: wrap;
    gap: 0.25rem;
    align-items: center;
    min-height: 38px;
    padding: 0.25rem;
    border: 1px solid var(--qb-border-color);
    border-radius: var(--qb-radius);
    background: #fff;
    flex: 1; /* Take available space */
    width: auto; /* Allow shrinking */
    min-width: 150px; /* Minimum width before wrapping might occur */
    max-width: 100%;
    box-sizing: border-box;
  }

  .qb-tag {
    display: inline-flex;
    align-items: center;
    background: var(--qb-primary-color);
    color: white;
    padding: 0.125rem 0.5rem;
    border-radius: var(--qb-radius);
    font-size: 0.875rem;
    max-width: 100%;
    box-sizing: border-box;
  }
  
  .qb-tag span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .qb-tag-remove {
    margin-left: 0.25rem;
    cursor: pointer;
    opacity: 0.8;
    font-weight: bold;
    flex-shrink: 0;
  }

  .qb-tag-remove:hover {
    opacity: 1;
  }

  .qb-tags-input {
    border: none;
    outline: none;
    flex: 1;
    min-width: 60px;
    padding: 0;
    margin: 0;
  }

  /* Searchable Select Styles */
  .qb-searchable-select {
    position: relative;
    display: inline-block;
    width: 200px;
    max-width: 100%;
  }

  .qb-searchable-select input {
    width: 100%;
    box-sizing: border-box;
  }

  .qb-dropdown-list {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: #fff;
    border: 1px solid var(--qb-border-color);
    border-radius: var(--qb-radius);
    max-height: 200px;
    overflow-y: auto;
    z-index: 1000;
    display: none;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    margin-top: 4px;
  }

  .qb-dropdown-list.show {
    display: block;
  }

  .qb-dropdown-item {
    padding: 0.5rem;
    cursor: pointer;
    font-size: 0.875rem;
  }

  .qb-dropdown-item:hover, .qb-dropdown-item.selected, .qb-dropdown-item.highlighted {
    background-color: #f3f4f6;
  }

  /* Already selected items in multi-select dropdown */
  .qb-dropdown-item.already-selected {
    background-color: #e0f2fe;
    position: relative;
    padding-right: 28px;  /* Space for checkmark on right (LTR) */
  }
  
  .qb-dropdown-item.already-selected::after {
    content: '✓';
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--qb-primary-color);
    font-weight: bold;
  }
  
  :host([dir="rtl"]) .qb-dropdown-item.already-selected {
    padding-right: 0.5rem;  /* Reset normal padding */
    padding-left: 28px;  /* Space for checkmark on left (RTL) */
  }
  
  :host([dir="rtl"]) .qb-dropdown-item.already-selected::after {
    right: auto;
    left: 8px;
  }

  /* RTL Support */
  :host([dir="rtl"]) .qb-tag-remove {
    margin-left: 0;
    margin-right: 0.25rem;
  }
  
  :host([dir="rtl"]) .qb-dropdown-list {
    text-align: right;
  }
`;
